export default __webpack_public_path__ + "static/media/material.67df1dd3.svg";